/* tslint:disable */
/* eslint-disable */
/**
 * accounts_api
 * Accounts rest api
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: cloudharness@metacell.us
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Keycloak User
 * @export
 * @interface User
 */
export interface User {
    [key: string]: object | any;
    /**
     * user id
     * @type {string}
     * @memberof User
     */
    id?: string;
    /**
     * Username of the keycloak user
     * @type {string}
     * @memberof User
     */
    username?: string;
    /**
     * Email address of the keycloak user
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * First Name of the keycloak user
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * Last Name of the keycloak user
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    readonly groups?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof User
     */
    profiles?: { [key: string]: object; };
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    registrationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    website?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof User
     */
    quotas?: { [key: string]: string; };
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'profiles': !exists(json, 'profiles') ? undefined : json['profiles'],
        'registrationDate': !exists(json, 'registrationDate') ? undefined : (new Date(json['registrationDate'])),
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'quotas': !exists(json, 'quotas') ? undefined : json['quotas'],
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'id': value.id,
        'username': value.username,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'profiles': value.profiles,
        'registrationDate': value.registrationDate === undefined ? undefined : (value.registrationDate.toISOString().substr(0,10)),
        'avatar': value.avatar,
        'website': value.website,
        'quotas': value.quotas,
    };
}


